import { trimStart } from 'lodash-es';
import {
  APP_HOSTNAMES,
  ENV_LOOKUP,
  NODE_ENVS,
  type AppEnv,
  type LanguageSymbols,
} from '#/shared/constants';

/** Environments that have a dedicated Smartling (translated) mirror */
const MIRRORED_ENVS: AppEnv[] = ['labs', 'beta', 'prod'];

export const LABS_SUBDOMAIN = 'labs';

/**
 * Three hosted versions of the strings files exist per language under three
 * subdomains; the prod instance of the app should use the `<locale>` subdomain,
 * beta should use `beta-<locale>`, everything else should use `labs-<locale>`
 *
 * To initiate the process of getting new strings translated deploy the app to
 * the domain that mirrors the strings file you're using, e.g. for
 * `labs-<locale>` deploy to `labs.trimet.org/home`, this will put in them
 * Smartling queue, and they'll be translated within a minute or two after
 * an admin approves them
 */
export const getStringsSubdomain = (locale: LanguageSymbols): string => {
  let baseSubdomain = LABS_SUBDOMAIN;

  // hosted instances run with NODE_ENV set to PROD
  if (process.env.NODE_ENV === NODE_ENVS.PROD) {
    const appEnv = ENV_LOOKUP[window.location.hostname];
    if (MIRRORED_ENVS.includes(appEnv)) {
      // one mirror exists per environment and its subdomain is derived
      // from first (primary) hostname for the env
      baseSubdomain = APP_HOSTNAMES[appEnv][0].split('.').at(-3) ?? '';
    }
  }

  // mirror subdomains are the base subdomain plus the locale
  return trimStart(`${baseSubdomain}-${locale}`, '-');
};
